
import React from 'react';
import { FacilityOrderTemplateNewFlowDeleteModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowDeleteModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowDeleteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowDeleteModalStore')
@observer
class FacilityOrderTemplateNewFlowDeleteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowDeleteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowDeleteModal;
